import { IBenefitDetails } from '../interfaces/benefits';
import { ICompanyContract } from '../interfaces/collaborators';
import {
  IFlexibleRemunerationConsumptions,
  IFlexibleRemunerationPayRollCycles,
  IFlexibleRemunerationWallet,
  ICompanyReportsResponse,
  IFlexibleRemunerationRequests
} from '../interfaces/company';
import { ICompanyPlan, ICompanyPlanResponse } from '../interfaces/plans';
import { IHealthReport } from '../interfaces/reports';

export const COMPANY_METRICS_RESPONSE_MOCK = {
  data: {
    id: 58,
    name: 'belsport',
    additionalInfo: {
      metrics: {
        all: {
          generation: {
            millennial: 0,
            centennial: 35,
            generation_x: 12,
            silent_generation: 3,
            baby_boomer: 7,
            generation_alpha: 18
          },
          state: {
            active: 90,
            inactive: 10
          },
          gender: {
            female: 55,
            non_binary: 10,
            male: 35
          },
          level: {
            super_giver: 25,
            ultimate_giver: 18,
            rookie: 25,
            giver: 25,
            betterflyer: 7
          }
        },
        active: {
          gender: {
            female: 55,
            non_binary: 10,
            male: 35
          },
          generation: {
            millennial: 25,
            centennial: 35,
            generation_x: 12,
            silent_generation: 3,
            baby_boomer: 7,
            generation_alpha: 18
          },
          level: {
            super_giver: 25,
            ultimate_giver: 18,
            rookie: 25,
            giver: 25,
            betterflyer: 7
          }
        },
        inactive: {
          gender: {
            female: 55,
            non_binary: 10,
            male: 35
          },
          generation: {
            millennial: 25,
            centennial: 35,
            generation: 12,
            silent_generation: 3,
            baby_boomer: 7,
            generation_alpha: 18
          },
          level: {
            super_giver: 25,
            ultimate_giver: 18,
            rookie: 25,
            giver: 25,
            betterflyer: 7
          }
        }
      }
    },
    sendEmail: false,
    locale: 'es-CL',
    countryCode: 'MX',
    clusterType: 'eager',
    companyGroup: 'micro',
    keyCompany: false,
    planId: '1',
    newExperience: true,
    integrations: {
      slack: true
    },
    dateToMigrate: '2024-02-20'
  }
};

export const COMPANY_AGREEMENTS_RESPONSE_MOCK = {
  data: {
    agreements: [
      {
        code: 'CL-SG-SG-01',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-SG-SG-02',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-SG-SG-03',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-SG-SG-04',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-SG-SG-05',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-SG-SG-06',
        name: 'SG 01',
        price: '9.99',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-ABO-ABO-01',
        name: 'abogados 1',
        price: '99900.00',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-ABO-ABO-02',
        name: 'abogados 2',
        price: '999.00',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-ABO-ABO-03',
        name: 'abogados 3',
        price: '999.00',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-ABO-ABO-04',
        name: 'errr',
        price: '655.64',
        currency: 'CLP',
        countryCode: 'CL'
      },
      {
        code: 'CL-ABO-ABO-05',
        name: 'dedfdf',
        price: '655.64',
        currency: 'BRL',
        countryCode: 'BR'
      },
      {
        code: 'CL-ABO-ABO-06',
        name: 'abogados 4',
        price: '99900.00',
        currency: 'USD',
        countryCode: 'US'
      }
    ]
  }
};

export const HOLDING_MOCK = {
  id: 1,
  name: 'HOLDING A',
  fullAccess: true,
  companies: [
    {
      id: '20',
      name: 'COMPANY A',
      countryCode: '',
      updatedAt: '2023-04-12T16:16:32.507Z',
      role: {
        name: 'default',
        permissions: ['menu', 'support-form']
      }
    },
    {
      id: '21',
      name: 'COMPANY B',
      countryCode: '',
      updatedAt: '2023-04-12T16:16:32.507Z',
      role: {
        name: 'affinity',
        permissions: ['menu', 'support-form']
      }
    }
  ]
};

export const COMPANY_MOCK = {
  id: '20',
  name: 'COMPANY A',
  countryCode: '',
  role: {
    name: 'first-payroll',
    permissions: ['menu.collaborators.collaborators-management']
  }
};

export const COMPANY_PAYMENT_URL_MOCK = {
  data: {
    url: 'mock url'
  }
};

export const CHANGE_COMPANY_DATA_MOCK_RESPONSE = {
  data: {
    id: 8,
    name: 'Cambio de nombre',
    image:
      'https://i.blogs.es/64df00/dragon-ball-este-es-el-diseno-original-de-goku-adulto-que-nunca-vimos-en-el-anime/1366_2000.jpeg'
  }
};

export const PLAN_MOCK_RESPONSE_NE = [
  {
    id: 101155,
    name: 'Plan Bfc Test 1',
    description: 'None',
    commercialPlanId: 232,
    price: 0.18,
    currency: 'CLP',
    countryCode: 'CL',
    isNewExperience: true,
    status: 'active',
    summary: {
      hasBenefits: true,
      hasInsurance: true,
      hasAddons: true,
      hasMarketplace: true
    },
    benefits: [
      {
        id: 60,
        title: 'Meditación',
        description:
          'Comienza un viaje para mejorar tu bienestar físico, emocional y espiritual con meditaciones guiadas, música relajante y más.',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_zen_456456.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_7d9ba0e3.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_02e97587726ea07f.png',
        providerName: 'Zen',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          },
          {
            id: 15,
            key: 'plan',
            value: 'common'
          }
        ],
        group: {
          id: '727',
          title: 'Meditación',
          description:
            '¡Duerme mejor y reduce el estrés! Comienza con sesiones guiadas junto a la plataforma más famosa de meditación.',
          icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_e4a5745f.png',
          cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_f8012fc2.png'
        }
      },
      {
        id: 41,
        title: 'Seguro de vida',
        description:
          'En Hanu Fit, tienes acceso a m\u00e1s de 20 disciplinas diferentes y miles de contenidos de fitness, wellness, nutrici\u00f3n y crecimiento personal, todo creado y organizado por destacados coaches de Latinoam\u00e9rica. \n\n\u00a1Comienza tu camino hacia un bienestar integral y la construcci\u00f3n de h\u00e1bitos m\u00e1s saludables!',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_6be29108.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_382156d0.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_19_74fd85ca006c6a2a.png',
        providerName: 'Hanufit',
        tags: [
          {
            id: 3,
            key: 'hub',
            value: 'insurance'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          }
        ]
      }
    ],
    benefitsBfu: [
      {
        availableChoices: 2,
        type: 'benefits',
        benefits: [
          {
            id: 'None',
            title: 'Seguro de cáncer',
            description:
              'Apoyo financiero para realizar exámenes preventivos de cáncer de mama o próstata, o en caso de recibir un primer diagnóstico de cáncer. Revisa coberturas o Solicitar indemnización.',
            icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_075a2e34.png',
            coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_98becab2.png',
            providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_a2db6e8ea16e86ff.png',
            providerName: 'Chubb Chile',
            tags: [
              {
                id: 1,
                key: 'hub',
                value: 'insurance'
              },
              {
                id: 10,
                key: 'category',
                value: 'Protección'
              },
              {
                id: 15,
                key: 'plan',
                value: 'common'
              }
            ],
            group: {
              id: '1453',
              title: 'Seguro de cáncer',
              description:
                'Beneficio que te apoya económicamente para realizar exámenes preventivos o en caso de recibir un primer diagnóstico de cáncer.',
              icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_d450306f.svg',
              cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_8251f35e.png'
            }
          },
          {
            id: 'None',
            title: 'Seguro dental',
            description:
              'Recibe atenciones dentales en clínicas en convenio, u obtén reembolsos de gastos por limpieza preventiva hasta dos veces al año. Revisa tu cobertura o solicita reembolsos.',
            icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_8fad5ba3.png',
            coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_eb008d01.png',
            providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_a2db6e8ea16e86ff.png',
            providerName: 'Chubb Chile',
            tags: [
              {
                id: 1,
                key: 'hub',
                value: 'insurance'
              },
              {
                id: 10,
                key: 'category',
                value: 'Protección'
              },
              {
                id: 15,
                key: 'plan',
                value: 'common'
              }
            ],
            group: {
              id: '1486',
              title: 'Seguro dental',
              description: 'Recibe atenciones dentales en clínicas en convenio, o reembolsos de gastos preventivos.',
              icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_3f5b5003.svg',
              cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_96d438aa.png'
            }
          }
        ]
      },
      {
        availableChoices: 3,
        type: 'insurance',
        benefits: [
          {
            id: 'None',
            title: 'Seguro de cáncer',
            description:
              'Apoyo financiero para realizar exámenes preventivos de cáncer de mama o próstata, o en caso de recibir un primer diagnóstico de cáncer. Revisa coberturas o Solicitar indemnización.',
            icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_075a2e34.png',
            coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_98becab2.png',
            providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_a2db6e8ea16e86ff.png',
            providerName: 'Chubb Chile',
            tags: [
              {
                id: 1,
                key: 'hub',
                value: 'insurance'
              },
              {
                id: 10,
                key: 'category',
                value: 'Protección'
              },
              {
                id: 15,
                key: 'plan',
                value: 'common'
              }
            ],
            group: {
              id: '1453',
              title: 'Seguro de cáncer',
              description:
                'Beneficio que te apoya económicamente para realizar exámenes preventivos o en caso de recibir un primer diagnóstico de cáncer.',
              icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_d450306f.svg',
              cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_8251f35e.png'
            }
          },
          {
            id: 'None',
            title: 'Seguro de cáncer 2',
            description:
              'Apoyo financiero para realizar exámenes preventivos de cáncer de mama o próstata, o en caso de recibir un primer diagnóstico de cáncer. Revisa coberturas o Solicitar indemnización.',
            icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_075a2e34.png',
            coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_98becab2.png',
            providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_a2db6e8ea16e86ff.png',
            providerName: 'Chubb Chile',
            tags: [
              {
                id: 1,
                key: 'hub',
                value: 'insurance'
              },
              {
                id: 10,
                key: 'category',
                value: 'Protección'
              },
              {
                id: 15,
                key: 'plan',
                value: 'common'
              }
            ],
            group: {
              id: '1453',
              title: 'Seguro de cáncer',
              description:
                'Beneficio que te apoya económicamente para realizar exámenes preventivos o en caso de recibir un primer diagnóstico de cáncer.',
              icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_d450306f.svg',
              cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_8251f35e.png'
            }
          },
          {
            id: 'None',
            title: 'Seguro dental',
            description:
              'Recibe atenciones dentales en clínicas en convenio, u obtén reembolsos de gastos por limpieza preventiva hasta dos veces al año. Revisa tu cobertura o solicita reembolsos.',
            icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_8fad5ba3.png',
            coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_eb008d01.png',
            providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_a2db6e8ea16e86ff.png',
            providerName: 'Chubb Chile',
            tags: [
              {
                id: 1,
                key: 'hub',
                value: 'insurance'
              },
              {
                id: 10,
                key: 'category',
                value: 'Protección'
              },
              {
                id: 15,
                key: 'plan',
                value: 'common'
              }
            ],
            group: {
              id: '1486',
              title: 'Seguro dental',
              description: 'Recibe atenciones dentales en clínicas en convenio, o reembolsos de gastos preventivos.',
              icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_3f5b5003.svg',
              cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_96d438aa.png'
            }
          }
        ]
      }
    ],
    addons: [
      {
        id: 2438,
        title: 'Rufy',
        description: 'Rufy',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_27f7c7a6.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_977e0ff3.jpg',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_4bf61c504e86028d.png',
        providerName: 'Rufy',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 8,
            key: 'category',
            value: 'Inversiones'
          },
          {
            id: 15,
            key: 'plan',
            value: 'common'
          }
        ],
        group: {
          id: '1',
          title: 'Meditación y bienestar',
          description: 'Encuentra la calma en ti. Medita por claridad, paz y auto descubrimiento.',
          icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_c51f53c8.png',
          cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_07fb3190.jpg'
        }
      },
      {
        id: 45,
        title: 'Salud en línea',
        description:
          'Accede a la plataforma de salud integral más grande de América Latina. Con profesionales que brindan la mejor experiencia al paciente a lo largo de su viaje de atención, integrando la salud física, emocional y conductual de una manera eficiente, democrática y asequible.',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_499a2c68.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_3b19d9e4.jpeg',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_21_62be370ab0a54fd5.png',
        providerName: 'Conexa',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 15,
            key: 'plan',
            value: 'common'
          }
        ],
        group: {
          id: '4',
          title: 'Entrenamiento físico',
          description: 'Cuida tu cuerpo y mente con la plataforma de entrenamiento más completa de latinoamérica.',
          icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_90b41031.png',
          cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_4db9991e.jpeg'
        }
      }
    ]
  },
  {
    id: 101155,
    name: 'Plan Bfc Test 2',
    description: 'None',
    commercialPlanId: 232,
    price: 0.18,
    currency: 'CLP',
    countryCode: 'CL',
    isNewExperience: true,
    status: 'active',
    summary: {
      hasBenefits: true,
      hasInsurance: true,
      hasAddons: true,
      hasMarketplace: true
    },
    benefits: [
      {
        id: 60,
        title: 'Meditación',
        description:
          'Comienza un viaje para mejorar tu bienestar físico, emocional y espiritual con meditaciones guiadas, música relajante y más.',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_zen_456456.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_7d9ba0e3.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_02e97587726ea07f.png',
        providerName: 'Zen',
        tags: [
          {
            id: 1,
            key: 'hub',
            value: 'insurance'
          },
          {
            id: 10,
            key: 'category',
            value: 'Protección'
          },
          {
            id: 15,
            key: 'plan',
            value: 'common'
          }
        ],
        group: {
          id: '727',
          title: 'Meditación',
          description:
            '¡Duerme mejor y reduce el estrés! Comienza con sesiones guiadas junto a la plataforma más famosa de meditación.',
          icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_e4a5745f.png',
          cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_f8012fc2.png'
        }
      },
      {
        id: 60,
        title: 'Meditación',
        description:
          'Comienza un viaje para mejorar tu bienestar físico, emocional y espiritual con meditaciones guiadas, música relajante y más.',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_zen_456456.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_7d9ba0e3.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_02e97587726ea07f.png',
        providerName: 'Zen',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          },
          {
            id: 15,
            key: 'plan',
            value: 'common'
          }
        ],
        group: {
          id: '727',
          title: 'Meditación',
          description:
            '¡Duerme mejor y reduce el estrés! Comienza con sesiones guiadas junto a la plataforma más famosa de meditación.',
          icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_e4a5745f.png',
          cover_image: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_f8012fc2.png'
        }
      }
    ],
    benefitsBfu: [
      {
        availableChoices: 2,
        benefits: []
      }
    ],
    addons: []
  },
  {
    id: 297,
    name: 'Plan Top',
    description:
      'El Plan Premium ofrece cobertura m\u00e9dica amplia, asistencia en carretera mejorada, atenci\u00f3n 24/7, acceso a especialistas y telemedicina ilimitada para quienes buscan una cobertura completa.',
    commercialPlanId: 1,
    price: 4.99,
    currency: 'USD',
    countryCode: 'CL',
    isNewExperience: true,
    status: 'active',
    summary: {
      hasBenefits: true,
      hasInsurance: true,
      hasMarketplace: true
    },
    benefits: [
      {
        id: 41,
        title: 'Hanu',
        description:
          'En Hanu Fit, tienes acceso a m\u00e1s de 20 disciplinas diferentes y miles de contenidos de fitness, wellness, nutrici\u00f3n y crecimiento personal, todo creado y organizado por destacados coaches de Latinoam\u00e9rica. \n\n\u00a1Comienza tu camino hacia un bienestar integral y la construcci\u00f3n de h\u00e1bitos m\u00e1s saludables!',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_6be29108.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_382156d0.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_19_74fd85ca006c6a2a.png',
        providerName: 'Hanufit',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          }
        ]
      },
      {
        id: 60,
        title: 'Meditaci\u00f3n y bienestar',
        description:
          'Zen ofrece meditaciones guiadas, m\u00fasica y diversos contenidos para que logres tu bienestar f\u00edsico, emocional y espiritual.\r\nTendr\u00e1s disponibles listas de reproducci\u00f3n para empezar bien el d\u00eda, as\u00ed como como audios para relajarte y sonidos de la naturaleza.\r\nAdem\u00e1s, podr\u00e1s conocer el estado general de tu salud emocional con la herramienta de seguimiento del estado de \u00e1nimo que incluye la app.\r\n\u00a1Emb\u00e1rcate en un viaje de autodescubrimiento con Zen!',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_5fece55f.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_5892ff71.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_02e97587726ea07f.png',
        providerName: 'Zen',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          },
          {
            id: 7,
            key: 'category',
            value: 'Formaci\u00f3n'
          }
        ]
      },
      {
        id: 41,
        title: 'Seguro de vida',
        description:
          'En Hanu Fit, tienes acceso a m\u00e1s de 20 disciplinas diferentes y miles de contenidos de fitness, wellness, nutrici\u00f3n y crecimiento personal, todo creado y organizado por destacados coaches de Latinoam\u00e9rica. \n\n\u00a1Comienza tu camino hacia un bienestar integral y la construcci\u00f3n de h\u00e1bitos m\u00e1s saludables!',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_6be29108.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_382156d0.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_19_74fd85ca006c6a2a.png',
        providerName: 'Hanufit',
        tags: [
          {
            id: 3,
            key: 'hub',
            value: 'insurance'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          }
        ]
      },
      {
        id: 41,
        title: 'Chubb',
        description:
          'En Hanu Fit, tienes acceso a m\u00e1s de 20 disciplinas diferentes y miles de contenidos de fitness, wellness, nutrici\u00f3n y crecimiento personal, todo creado y organizado por destacados coaches de Latinoam\u00e9rica. \n\n\u00a1Comienza tu camino hacia un bienestar integral y la construcci\u00f3n de h\u00e1bitos m\u00e1s saludables!',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_6be29108.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_382156d0.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_19_74fd85ca006c6a2a.png',
        providerName: 'Chubb Chile',
        tags: [
          {
            id: 3,
            key: 'hub',
            value: 'insurance'
          },
          {
            id: 5,
            key: 'category',
            value: 'Bienestar'
          }
        ],
        group: {
          id: '727',
          title: 'Meditación',
          description:
            '¡Duerme mejor y reduce el estrés! Comienza con sesiones guiadas junto a la plataforma más famosa de meditación.',
          icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_e4a5745f.png',
          coverImage: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_f8012fc2.png'
        }
      },
      {
        id: null,
        title: 'Telemedicina',
        description:
          '¡Consulta a médicos, especialistas, psicólogos y nutricionistas a través de videollamadas y mensajería en línea! Obtén orientación médica, diagnósticos y recetas desde la comodidad de tu hogar.',
        icon: 'https://static.techbetterfly.com/catalog/benefitcontent/icon_715c7081.png',
        coverImage: 'https://static.techbetterfly.com/catalog/benefitcontent/cover_cdddad60.png',
        providerLogo: 'https://media.techbetterfly.com/insurance/service_provider/logo_None_ead650ac782b23d0.png',
        providerName: 'Medismart',
        tags: [
          {
            id: 2,
            key: 'hub',
            value: 'wellbeing'
          },
          {
            id: 6,
            key: 'category',
            value: 'Salud'
          },
          {
            id: 14,
            key: 'plan',
            value: 'premium'
          }
        ],
        group: {
          id: '1354',
          title: 'Telemedicina',
          description:
            'Atención en línea de médicos generales y especialistas, incluyendo psicólogos y nutricionistas.',
          icon: 'https://static.techbetterfly.com/catalog/benefitgroup/icon_743f5b41.png',
          coverImage: 'https://static.techbetterfly.com/catalog/benefitgroup/cover_d4e08e9e.png'
        }
      }
    ],
    available_choices_bfu: 2
  }
];

export const COMPANY_DOMAINS_MOCK = {
  10115: [
    {
      id: 1,
      name: '@example.com'
    }
  ]
};

const MOCK_BENEFIT_ICON_URL = 'https://static.gobetterfly.com/catalog/benefitcontent/icon_3cd9aefc.png';

export const MOCK_COMPANY_SELECTED_BENEFITS = {
  '0': {
    name: 'Todos',
    id: '0',
    data: [
      {
        title: 'Beneficio1',
        id: '1',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '30'
      },
      {
        title: 'Beneficio2',
        id: '2',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '15'
      },
      {
        title: 'beneficio3',
        id: '3',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '10'
      }
    ]
  },
  '6': {
    name: 'Bienestar',
    id: '6',
    data: [
      {
        title: 'Beneficio4',
        id: '4',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '20'
      },
      {
        title: 'Beneficio5',
        id: '5',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '18'
      }
    ]
  },
  '7': {
    name: 'Seguros',
    id: '7',
    data: [
      {
        title: 'Title 3',
        id: '6',
        icon: MOCK_BENEFIT_ICON_URL,
        value: '1'
      }
    ]
  }
};

export const BANNER_MOCK = {
  banners: [
    {
      id: '12nasdoias81i2',
      type: 'classic',
      title: 'Collaborators title',
      description: 'Banner description with a lot of characters, this is a test to see how it looks in the app',
      backgroundColor: '#47c468',
      contentUrl: null,
      category: 'Classic',
      label: 'New',
      callToAction: {
        text: 'Go to collaborators',
        route: ''
      }
    },
    {
      id: '12nasdoias81i3',
      type: 'classic',
      title: 'Plan title',
      description:
        'Banner description about plans with a lot of characters, this is a test to see how it looks in the app',
      backgroundColor: '#4764c4',
      contentUrl: null,
      category: 'Classic',
      callToAction: {
        text: 'Go to plans',
        route: '/plan'
      }
    },
    {
      id: '12nasdoias81i4',
      type: 'classic',
      title: 'This is an unnecessary long title in order to test how it looks in the app, on the home banner',
      description:
        'Banner description about metrics with a lot of characters, this is a test to see how it looks in the app. But what would really happen if both title and description are too long tho... will we ever get to see the end of this? How many text lines is this component going to support before it breaks? I guess we will never know',
      backgroundColor: '',
      contentUrl: 'https://media.content-mgmt.platform.betterfly.com/preview/oEVivYPr9XDwj5waFPHIX',
      category: 'Classic',
      callToAction: {
        text: 'Go to metrics',
        route: '/betterfly-effect/metrics'
      }
    }
  ]
};

export const MOCK_COMPANY_PLANS: ICompanyPlanResponse = {
  plans: [
    {
      id: 105488,
      name: 'Plan de prueba',
      description: 'Nivel de protección Básico',
      commercialPlanId: 2444,
      price: 5.0,
      currency: 'UF',
      countryCode: 'CL',
      isNewExperience: true,
      status: 'active',
      type: 'basic',
      supportDependents: true,
      supportRequests: false,
      addons: [
        {
          id: 2020,
          name: 'Betterfly',
          description: 'Addon bfc',
          price: 2024,
          currency: 'UF',
          status: 'active'
        },
        {
          id: 2020,
          name: 'Udemy',
          description: 'Addon bfc',
          price: 2024,
          currency: 'UF',
          status: 'active'
        }
      ]
    },
    {
      id: 105492,
      name: 'Prueba Nacho',
      description: 'pruebas nacho',
      commercialPlanId: 562,
      price: 1000.0,
      currency: 'CLP',
      countryCode: 'CL',
      isNewExperience: true,
      status: 'active',
      supportDependents: true,
      supportRequests: true,
      type: 'flexible_remuneration',
      addons: []
    }
  ] as ICompanyPlan[],
  type: 'health'
};

export const MOCK_COMPANY_CONTRACT: ICompanyContract = {
  type: 'exceed_licenses',
  availableLicenses: 0,
  price: 5.0,
  currency: 'UF',
  startDate: '2023-10-01'
};

export const MOCK_BENEFIT_DETAIL: IBenefitDetails = {
  title: 'Programa de Bienestar',
  description: 'Un programa integral de bienestar.',
  providerName: 'Medismart',
  icon: 'https://static.techbetterfly.com/benefits/provider/logo_30cf3c4e.png',
  category: 'wellbeing',
  steps: ['Paso 1: Haz esto.', 'Paso 2: Haz aquello.'],
  coverImage: 'https://static.techbetterfly.com/benefits/catalog/benefitcontent/cover_de567a39.gif'
};

export const MOCK_COMPANY_FLEXIBLE_REMUNERATION_WALLET: IFlexibleRemunerationWallet = {
  balance: 1000,
  currency: 'EUR',
  payRollDay: 15,
  minThreshold: 100
};

export const MOCK_COMPANY_REPORTS_RESPONSE: ICompanyReportsResponse = {
  reports: [
    {
      period: '2025-07-01',
      generationDate: '01/08/2025',
      lastUpdate: '',
      status: 'open'
    },
    {
      period: '2024-10-01',
      generationDate: '01/11/2024',
      lastUpdate: '27/11/2024',
      status: 'closed'
    },
    {
      period: '2024-06-01',
      generationDate: '01/07/2024',
      lastUpdate: '29/07/2024',
      status: 'closed'
    }
  ]
};

export const MOCK_COMPANY_FLEXIBLE_REMUNERATION_PAYROLL_CYCLE: IFlexibleRemunerationPayRollCycles = {
  payRollCycles: [
    {
      id: '2696bdf0-39d9-438b-99fb-a9f4eefc8658',
      cycleYear: 2025,
      cycleMonth: 7,
      startDay: '2025-06-21',
      endDay: '2025-07-20',
      status: 'OPEN'
    },
    {
      id: 'b1eb60a4-7008-414d-8a52-8f3c8a3a6300',
      cycleYear: 2025,
      cycleMonth: 6,
      startDay: '2025-05-20',
      endDay: '2025-06-20',
      status: 'CLOSED'
    }
  ]
};

export const MOCK_COMPANY_FLEXIBLE_REMUNERATION_CONSUMPTIONS: IFlexibleRemunerationConsumptions = {
  consumptions: [
    {
      sku: 'flexible-remuneration-meal',
      accumulatedBalance: 3,
      savedBalance: 1.11,
      currency: 'EUR'
    },
    {
      sku: 'flexible-remuneration-health',
      accumulatedBalance: 0,
      savedBalance: 0,
      currency: 'EUR'
    },
    {
      sku: 'flexible-remuneration-nursery',
      accumulatedBalance: 0,
      savedBalance: 0,
      currency: 'EUR'
    },
    {
      sku: 'flexible-remuneration-transport',
      accumulatedBalance: 0,
      savedBalance: 0,
      currency: 'EUR'
    }
  ],
  totalBalance: 3,
  totalSavedBalance: 1.11,
  currency: 'EUR'
};

export const MOCK_DOWNLOAD_REPORT_RESPONSE = {
  data: {
    url: 'https://google.com'
  }
};

export const MOCK_HEALTH_REPORT_DATA: IHealthReport = {
  generationDate: '2025-10-31',
  currency: 'CLP',
  isFirstReport: false,
  insuredMembers: 132,
  nonInsuredMembers: 24,
  totalDependents: 51,
  totalClaims: 462,
  totalSavingsAmount: 8090.06,
  totalUsersClaims: 54,
  approvedClaims: 0.66,
  imedRate: 0,
  insuranceUseRate: 0.5,
  usersApprovedClaimsPercentage: 28.8,
  savingsData: [
    {
      label: 'Medicina 1',
      value: 0.4
    },
    {
      label: 'Medicina 2',
      value: 0.24
    },
    {
      label: 'Medicina 3',
      value: 0.16
    },
    {
      label: 'Medicina 4',
      value: 0.06
    },
    {
      label: 'Medicina 5',
      value: 0.06
    },
    {
      label: 'Medicina 6',
      value: 0.03
    },
    {
      label: 'Medicina 7',
      value: 0.02
    },
    {
      label: 'Medicina 8',
      value: 0.01
    },
    {
      label: 'Medicina 9',
      value: 0.01
    },
    {
      label: 'Medicina 10',
      value: 0.01
    }
  ],
  onboardingPercentage: 0.93,
  benefitsUseIntentionPercentage: 0.8,
  activityData: {
    averageSteps: 6410.98,
    averageStepsInsight: 0,
    averageTrainingMinutes: 64.81,
    averageTrainingMinutesInsight: 0,
    averageMeditationMinutes: 19.15,
    averageMeditationMinutesInsight: -10
  },
  topBenefits: [
    {
      providerName: 'Medismart',
      providerLogo: 'https://static.techbetterfly.com/benefits/provider/logo_30cf3c4e.png',
      category: 'health',
      percentage: 0.27
    },
    {
      providerName: 'Marketcare',
      providerLogo: 'https://static.techbetterfly.com/benefits/provider/marketcare_logo_5681a294.png',
      category: 'health',
      percentage: 0.21
    }
  ],
  marketcareBenefitPercentage: 0.21,
  marketcareBenefitInsight: 0,
  medismartBenefitPercentage: 0.27,
  medismartBenefitInsight: 0,
  usersChallengesPercentage: 0.88,
  usersDonationsPercentage: 125.6,
  topChallenges: [
    {
      challengeType: 'steps',
      percentage: 0.2,
      users: 164
    },
    {
      challengeType: 'training',
      percentage: 0.15,
      users: 120
    },
    {
      challengeType: 'active-minutes',
      percentage: 0.11,
      users: 92
    }
  ],
  totalDonations: 5559,
  totalDonationsInsight: 5,
  totalFoundations: 12,
  totalFoundationsInsight: -7,
  totalDonorUsers: 196,
  totalDonorUsersInsight: 20,
  topCauses: [
    {
      label: 'Agua',
      value: 1261
    },
    {
      label: 'Árboles',
      value: 20
    },
    {
      label: 'Comida',
      value: 15
    },
    {
      label: 'Comida2',
      value: 1
    }
  ],
  medicalCheckoutPercentage: 0.64,
  physicalActivityPercentage: 0.64,
  stressedUsersPercentage: 0.64,
  sleepQualityPercentage: 0.64,
  meditationUseIntention: 0.3,
  trainingUseIntention: 0.4,
  stepsChallengeParticipation: 0.75,
  telemedicineData: [
    {
      label: 'Consulta general',
      value: 29
    },
    {
      label: 'Consulta veterinaria',
      value: 1
    },
    {
      label: 'Nutrición y dietética',
      value: 4
    },
    {
      label: 'Salud mental',
      value: 4
    },
    {
      label: 'Consulta especialista (geriatria y dermatologia)',
      value: 2
    },
    {
      label: 'Consulta kinesiología',
      value: 2
    }
  ],
  telemedicineConsultations: 183,
  telemedicineUsersServed: 60,
  telemedicineUsePercentage: 38
};

export const MOCK_HEALTH_REPORT_LIST = {
  reports: [
    {
      startDate: '2025-01-01',
      endDate: '2025-03-31',
      status: 'generated',
      generationDate: '2025-10-22',
      dateStartHealth: '2024-12-03'
    },
    {
      startDate: '2025-04-01',
      endDate: '2025-06-30',
      status: 'generated',
      generationDate: '2025-10-22',
      dateStartHealth: '2024-12-03'
    },
    {
      startDate: '2025-07-01',
      endDate: '2025-09-30',
      status: 'generated',
      generationDate: '2025-10-22',
      dateStartHealth: '2024-12-03'
    },
    {
      startDate: '2025-10-01',
      endDate: '2025-12-31',
      status: 'pending',
      generationDate: '2025-10-22',
      dateStartHealth: '2024-12-03'
    }
  ]
};

export const MOCK_COMPANY_FLEXIBLE_REMUNERATION_REQUESTS: IFlexibleRemunerationRequests = {
  requests: [
    {
      id: 'req_001',
      sku: 'training',
      type: 'Formación',
      category: 'training',
      amount: 250,
      createdAt: '2025-09-23T18:12:49.373Z',
      status: 'pending',
      currency: 'EUR',
      member: {
        playerId: 'player_001',
        firstName: 'Prueba',
        lastName: 'Prueba',
        birthdate: '1990-05-15',
        phone: '+34123456789',
        nationalId: '12345678A',
        nationalType: 'DNI',
        address: {
          street: 'Calle Principal 123',
          city: 'Madrid'
        }
      },
      details: {
        name: 'Máster',
        description: 'Universidad',
        type: 'course',
        startDate: '2026-01-01T00:00:00.000',
        endDate: '2026-02-02T00:00:00.000',
        centerName: 'Universidad',
        contactData: {
          email: 'Nombre@edu.com',
          contactName: 'Pedro',
          phone: '+34123456789'
        },
        payments: [
          { month: '2025-07', amount: 125 },
          { month: '2025-08', amount: 125 },
          { month: '2025-09', amount: 125 },
          { month: '2025-10', amount: 125 },
          { month: '2025-11', amount: 125 },
          { month: '2025-12', amount: 125 }
        ]
      }
    },
    {
      id: 'req_002',
      sku: 'health',
      type: 'Seguro de Salud',
      category: 'health',
      amount: 50000,
      createdAt: '2026-01-10T10:30:00.000Z',
      status: 'pending',
      currency: 'CLP',
      member: {
        playerId: 'player_002',
        firstName: 'María',
        lastName: 'González',
        birthdate: '1985-03-20',
        phone: '+56912345678',
        nationalId: '12345678-9',
        nationalType: 'RUT',
        address: {
          street: 'Av. Providencia 1234',
          city: 'Santiago'
        }
      },
      details: {
        name: 'Seguro Complementario de Salud',
        description: 'Cobertura adicional para gastos médicos',
        type: 'health',
        startDate: '2026-02-01',
        endDate: '2027-01-31',
        centerName: '',
        policyNumber: 'POL-987654',
        insuranceCompanyName: 'Cruz Blanca',
        contactData: {
          email: '',
          phone: '',
          contactName: ''
        },
        payments: []
      }
    },
    {
      id: 'req_003',
      sku: 'training',
      type: 'Formación',
      category: 'training',
      amount: 150,
      createdAt: '2025-11-15T14:20:00.000Z',
      status: 'active',
      currency: 'EUR',
      member: {
        playerId: 'player_003',
        firstName: 'Carlos',
        lastName: 'Fernández',
        birthdate: '1992-07-10',
        phone: '+34987654321',
        nationalId: '87654321B',
        nationalType: 'DNI',
        address: {
          street: 'Calle Secundaria 456',
          city: 'Barcelona'
        }
      },
      details: {
        name: 'Curso de Programación',
        description: 'Desarrollo web full-stack',
        type: 'material',
        startDate: '2025-12-01',
        endDate: '2026-03-31',
        centerName: 'Academia Online',
        contactData: {
          email: 'contacto@academia.com',
          phone: '+34111222333',
          contactName: 'Laura'
        },
        payments: [{ month: '2025-12', amount: 150 }]
      }
    }
  ]
};
